export default __webpack_public_path__ + "static/media/ipl.8a243335.pdf";